import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AssignmentsCommunicationService } from "./assignments-communication.service";
import { AssignmentCommunicationModel } from "../models/assignment-communication.model";

@Injectable({
    providedIn: 'root'
})

export class AssignmentsCommunicationStateService {
    public assignmentCommunicationSubject = new BehaviorSubject<AssignmentCommunicationModel | null>(null);
    public isNotesVisible = new BehaviorSubject<boolean | null>(null);
    public isNotesEditable = new BehaviorSubject<boolean | null>(null);
    public isUpdateVisible = new BehaviorSubject<boolean | null>(null);
    public isUpdateEditable = new BehaviorSubject<boolean | null>(null);

    constructor(private assignmentCommunicationService: AssignmentsCommunicationService) { }

    public loadAssignmentCommunication(assignmentId: number): void {
        this.assignmentCommunicationSubject.next(null);

        this.assignmentCommunicationService.getAssignmentCommunication(assignmentId).subscribe({
            next: assignmentCommunication => {
                this.assignmentCommunicationSubject.next(assignmentCommunication);
                this.calculateNotesState(assignmentCommunication);
                this.calculateUpdateState(assignmentCommunication);
            },
            error: (error) => {
            }
        })
    }

    private calculateNotesState(communicationModel: AssignmentCommunicationModel | null) {
        if (communicationModel == null) {
            this.isNotesVisible.next(null);
            this.isNotesEditable.next(null);
            return;
        }

        this.isNotesEditable.next(communicationModel.isChangingNotesAllowed);

        // if changing is allowed, the field needs to be displayed
        if (communicationModel.isChangingNotesAllowed) {
            this.isNotesVisible.next(true);
            return;
        }

        this.isNotesVisible.next(!this.isNullOrWhiteSpaces(communicationModel.note));
    }

    private calculateUpdateState(communicationModel: AssignmentCommunicationModel | null) {
        if (communicationModel == null) {
            this.isUpdateVisible.next(null);
            this.isUpdateEditable.next(null);
            return;
        }

        this.isUpdateEditable.next(communicationModel.isChangingUpdateAllowed);

        // if changing is allowed, the field needs to be displayed
        if (communicationModel.isChangingUpdateAllowed) {
            this.isUpdateVisible.next(true);
            return;
        }

        this.isUpdateVisible.next(!this.isNullOrWhiteSpaces(communicationModel.update));
    }

    private isNullOrWhiteSpaces(str: string | null) {
        return str === null || str.match(/^ *$/) !== null;
    }
}

